module.exports = __webpack_public_path__ + "media/img/favicon-16x16-4284d1f5fcba2567f913532224ecffe8.png";